import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getShiftDefinitions = (params: any = {}) => {
  const query = new URLSearchParams();
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  return api.get(`${BASE_URL}/api/v1/shift-definitions${queryString ? `?${queryString}` : ""}`);
};

export const getShiftDefinition = (id: number) => {
  return api.get(`${BASE_URL}/api/v1/shift-definitions/${id}`);
};

export const saveShiftDefinition = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/shift-definitions`, camelToSnake(payload));
};

export const updateShiftDefinition = (payload: any) => {
  return api.put(`${BASE_URL}/api/v1/shift-definitions/${payload.id}`, camelToSnake(payload));
};
